import React from 'react';
import { IoIosArrowRoundDown, IoIosArrowRoundUp } from 'react-icons/io';
import verticalIcon from '../../../../../assets/image/vertical-icon.svg';

export default function AccountListTable({
	columns,
	row,
	sortDataList,
	sortDirection,
	setAccountId,
	onRowClick,
	setIsOpenAccountsModal,
	setIsOpenDeactivateConfirmAccountModal,
	accountType,
	setIsOpenDeleteModal,
}) {
	const sortIconMap = {
		asc: <IoIosArrowRoundUp />,
		desc: <IoIosArrowRoundDown />,
	};

	const getStatusText = (status) => {
		switch (status) {
			case 1:
				return 'Active';
			case 0:
				return 'Inactive';
			default:
				return '';
		}
	};
	const getStatusColor = (status) => {
		switch (status) {
			case 1:
				return '#68C230';
			case 0:
				return '#FF0000';
			default:
				return '';
		}
	};

	const dropdownOptions = ['View', 'Edit', 'Delete', 'Deactivate'];

	return (
		<div
			className="table-container"
			style={{ height: accountType === 'accounts' ? 'calc(100vh - 236px)' : 'calc(100vh - 150px)' }}
		>
			<table className="custom-table">
				<thead>
					<tr>
						{columns.map((m, idx) => (
							<th
								key={idx}
								className="cursor-pointer"
								onClick={() => {
									sortDataList({ order_by: m.key });
								}}
							>
								<div className="fs-5 fw-bold d-flex justify-content-start align-items-center gap-4">
									{m.label}
									{sortIconMap[sortDirection[m.key]]}
								</div>
							</th>
						))}
					</tr>
				</thead>

				<tbody>
					{row.map((rowItem, i) => (
						<tr key={i}>
							{columns.map((m, idx) => {
								if (m.key !== 'action') {
									return (
										<td
											key={`${i}-${idx}`}
											className="fs-5 fw-light cursor-pointer"
											style={{
												color: m.key === 'status' ? getStatusColor(rowItem[m.key]) : '#000',
											}}
											onClick={() => {
												if (accountType !== 'parent-account') {
													onRowClick(rowItem.id);
												}
											}}
										>
											{m.key === 'status' ? getStatusText(rowItem[m.key]) : rowItem[m.key]}
										</td>
									);
								}

								return accountType === 'accounts' ? (
									<td
										key={`${i}-${idx}`}
										onClick={(e) => e.stopPropagation()}
									>
										<div className="dropdown d-flex justify-content-center">
											<button
												type="button"
												className="border-0 bg-transparent p-0 justify-content-center"
												id={`dropdown-${rowItem.id}`}
												data-bs-toggle="dropdown"
												aria-expanded="false"
												onClick={(e) => e.stopPropagation()}
											>
												<img
													src={verticalIcon}
													alt="icon"
													width="20"
													height="20"
													className="rounded-circle cursor-pointer"
												/>
											</button>
											<ul
												className="dropdown-menu dropdown-menu-center"
												aria-labelledby={`dropdown-${rowItem.id}`}
											>
												{dropdownOptions.map((option, index) => (
													<li key={index}>
														<div
															className="p-2 dropdown-item border-0 fs-5 fw-light"
															onClick={(e) => {
																e.stopPropagation();
																if (option === 'View') {
																	onRowClick(rowItem.id);
																}
																if (option === 'Edit') {
																	setIsOpenAccountsModal(true);
																}
																if (option === 'Deactivate') {
																	setIsOpenDeactivateConfirmAccountModal(true);
																}
																if (option === 'Delete') {
																	setIsOpenDeleteModal(true);
																}
																setAccountId(rowItem.id);
															}}
														>
															{option}
														</div>
													</li>
												))}
											</ul>
										</div>
									</td>
								) : (
									<td>
										<div className="d-flex justify-content-center gap-4">
											<div
												className="fs-5 fw-light rounded-4 px-4 py-3 cursor-pointer text-white bg-primary"
												onClick={(e) => {
													// onRowClick(rowItem.id);
													setIsOpenAccountsModal(true);
													setAccountId(rowItem.id);
												}}
											>
												{'Edit'}
											</div>
											<div
												className="fs-5 fw-light rounded-4 px-4 py-3 cursor-pointer text-white bg-danger"
												onClick={(e) => {
													setIsOpenDeactivateConfirmAccountModal(true);
													setAccountId(rowItem.id);
												}}
											>
												{'Delete'}
											</div>
										</div>
									</td>
								);
							})}
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
}
